


  
  

  var faCheckIn = {
    prefix: 'fak',
    iconName: 'check-in',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M250.3 32c7.7 0 14 6.3 14 14l0 42 168 0 0-42c0-7.7 6.3-14 14-14s14 6.3 14 14l0 42 28 0c30.9 0 56 25.1 56 56l0 280c0 30.9-25.1 56-56 56l-280 0c-30.9 0-56-25.1-56-56l0-22.4 28 0 0 22.4c0 15.5 12.5 28 28 28l280 0c15.5 0 28-12.5 28-28l0-224-336 0 0 33.6-28 0 0-89.6c0-30.9 25.1-56 56-56l28 0 0-42c0-7.7 6.3-14 14-14zm238 84l-280 0c-15.5 0-28 12.5-28 28l0 28 336 0 0-28c0-15.5-12.5-28-28-28zM212.1 243.4c5.2-4.8 13.3-4.5 18.1 .6l65.5 70.2c2.3 2.5 3.5 5.7 3.4 8.9c0 3.2-1.1 6.4-3.4 8.9l-65.5 70.2c-4.8 5.2-12.9 5.5-18.1 .6s-5.5-12.9-.6-18.1l46.8-50.2-149.4 0c-7.1 0-12.8-5.7-12.8-12.8s5.7-12.8 12.8-12.8l147 0-44.4-47.6c-4.8-5.2-4.5-13.3 .6-18.1z'
      
    ]
  };

  

  
  

  var faCheckInAlt = {
    prefix: 'fak',
    iconName: 'check-in-alt',
    icon: [
      512,
      512,
      [],
      'e00b',
      
      'M153.7 229.9c-4.5-4.8-12.3-4.8-16.8 0-4.5 4.7-4.5 12.4 0 17.1l64.1 67.3-170 0c-6.7 0-11.9 5.6-11.9 12.1s5.1 12.1 11.9 12.1l170 0-64.1 67.3c-4.5 4.7-4.5 12.4 0 17.1 4.5 4.8 12.3 4.8 16.8 0l83.9-88c4.5-4.7 4.5-12.4 0-17.1l-83.9-88zM156.8 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-25.6 32 0 0 25.6c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-384.1 0 0 38.4-32 0 0-102.4c0-35.3 28.7-64 64-64l32 0 0-48c0-8.8 7.2-16 16-16l.1 0zm-48 96c-17.7 0-32 14.3-32 32l0 32 384.1 0 0-32c0-17.7-14.3-32-32-32l-320 0-.1 0z'
      
    ]
  };

  

  
  

  var faCheckInDate = {
    prefix: 'fak',
    iconName: 'check-in-date',
    icon: [
      512,
      512,
      [],
      'e009',
      
      'M179.3 223.6c-3.4-3.6-9.2-3.6-12.6 0-3.4 3.5-3.4 9.3 0 12.8l48.1 50.5-127.5 0c-5 0-8.9 4.2-8.9 9.1s3.8 9.1 8.9 9.1l127.5 0-48.1 50.5c-3.4 3.5-3.4 9.3 0 12.8 3.4 3.6 9.2 3.6 12.6 0l62.9-66c3.4-3.5 3.4-9.3 0-12.8l-62.9-66zm2.3-172.4c6.6 0 12 5.4 12 12l0 36 144 0 0-36c0-6.6 5.4-12 12-12s12 5.4 12 12l0 36 24 0c26.5 0 48 21.5 48 48l0 240c0 26.5-21.5 48-48 48l-240 0c-26.5 0-48-21.5-48-48l0-19.2 24 0 0 19.2c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24l0-192-288.1 0 0 28.8-24 0 0-76.8c0-26.5 21.5-48 48-48l24 0 0-36c0-6.6 5.4-12 12-12zm-36 72c-13.3 0-24 10.7-24 24l0 24 288.1 0 0-24c0-13.3-10.7-24-24-24l-240 0z'
      
    ]
  };

  

  
  

  var faCheckOut = {
    prefix: 'fak',
    iconName: 'check-out',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M226 32c7.7 0 14 6.3 14 14l0 42 168 0 0-42c0-7.7 6.3-14 14-14s14 6.3 14 14l0 42 28 0c30.9 0 56 25.1 56 56l0 89.6-28 0 0-33.6-336 0 0 224c0 15.5 12.5 28 28 28l280 0c15.5 0 28-12.5 28-28l0-22.4 28 0 0 22.4c0 30.9-25.1 56-56 56l-280 0c-30.9 0-56-25.1-56-56l0-280c0-30.9 25.1-56 56-56l28 0 0-42c0-7.7 6.3-14 14-14zm238 84l-280 0c-15.5 0-28 12.5-28 28l0 28 336 0 0-28c0-15.5-12.5-28-28-28zM436.1 243.4c5.2-4.8 13.3-4.5 18.1 .6l65.5 70.2c2.3 2.5 3.5 5.7 3.4 8.9c0 3.2-1.1 6.4-3.4 8.9l-65.5 70.2c-4.8 5.2-12.9 5.5-18.1 .6s-5.5-12.9-.6-18.1l46.8-50.2-149.4 0c-7.1 0-12.8-5.7-12.8-12.8s5.7-12.8 12.8-12.8l147 0-44.4-47.6c-4.8-5.2-4.5-13.3 .6-18.1z'
      
    ]
  };

  

  
  

  var faCheckOutAlt = {
    prefix: 'fak',
    iconName: 'check-out-alt',
    icon: [
      512,
      512,
      [],
      'e00a',
      
      'M157.5 16c0-8.8-7.5-16-16.7-16s-16.7 7.2-16.7 16l0 48-33.3 0C54 64 24 92.7 24 128l0 320c0 35.3 29.9 64 66.8 64l333.7 0c36.8 0 66.8-28.7 66.8-64l0-25.6-33.3 0 0 25.6c0 17.7-14.9 32-33.3 32L90.9 480c-18.4 0-33.3-14.3-33.3-32l0-256 400.4 0 0 38.4 33.3 0 0-102.4c0-35.3-29.9-64-66.8-64l-33.3 0 0-48c0-8.8-7.5-16-16.7-16s-16.7 7.2-16.7 16l0 48-200.3 0 0-48-.1 0zM90.7 96l333.7 0c18.4 0 33.3 14.3 33.3 32l0 32-400.4 0 0-32c0-17.7 14.9-32 33.3-32zM381.3 229.9c-4.5-4.8-12.1-4.8-16.8 0-4.5 4.7-4.5 12.4 0 17.1l64 67.3-169.9 0c-6.7 0-11.7 5.6-11.7 12.1s5.1 12.1 11.7 12.1l169.9 0-64 67.3c-4.5 4.7-4.5 12.4 0 17.1 4.5 4.8 12.1 4.8 16.8 0l83.7-88c4.5-4.7 4.5-12.4 0-17.1l-83.7-88z'
      
    ]
  };

  

  
  

  var faCheckOutDate = {
    prefix: 'fak',
    iconName: 'check-out-date',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M180.9 63.2c0-6.6-5.6-12-12.5-12s-12.5 5.4-12.5 12l0 36-25 0c-27.6 0-50.1 21.5-50.1 48l0 240c0 26.5 22.4 48 50.1 48l250.3 0c27.6 0 50.1-21.5 50.1-48l0-19.2-25 0 0 19.2c0 13.3-11.2 24-25 24l-250.3 0c-13.8 0-25-10.7-25-24l0-192 300.3 0 0 28.8 25 0 0-76.8c0-26.5-22.4-48-50.1-48l-25 0 0-36c0-6.6-5.6-12-12.5-12s-12.5 5.4-12.5 12l0 36-150.2 0 0-36zm-50.1 60l250.3 0c13.8 0 25 10.7 25 24l0 24-300.3 0 0-24c0-13.3 11.2-24 25-24zM348.8 223.6c-3.4-3.6-9.1-3.6-12.6 0-3.4 3.5-3.4 9.3 0 12.8l48 50.5-127.4 0c-5 0-8.8 4.2-8.8 9.1s3.8 9.1 8.8 9.1l127.4 0-48 50.5c-3.4 3.5-3.4 9.3 0 12.8 3.4 3.6 9.1 3.6 12.6 0l62.8-66c3.4-3.5 3.4-9.3 0-12.8l-62.8-66z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fak',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M206.1 86c-31.1 0-56.3 25.2-56.3 56.3s25.2 56.3 56.3 56.3s56.3-25.2 56.3-56.3s-25.2-56.3-56.3-56.3zM121 119C131.3 81.5 165.5 54 206.1 54c48.7 0 88.2 39.5 88.2 88.2s-39.5 88.2-88.2 88.2c-45.8 0-83.4-34.9-87.8-79.6l-81.4 0c-8.8 0-16-7.1-16-16s7.1-16 16-16l84 0zm202.3 16c0-8.8 7.1-16 16-16l136.5 0c8.8 0 16 7.1 16 16s-7.1 16-16 16l-136.5 0c-8.8 0-16-7.1-16-16zM306.3 313c-31.1 0-56.3 25.2-56.3 56.3s25.2 56.3 56.3 56.3s56.3-25.2 56.3-56.3s-25.2-56.3-56.3-56.3zm-88.2 56.3c0-48.7 39.5-88.2 88.2-88.2c40.5 0 74.6 27.3 85 64.5l84.6 0c8.8 0 16 7.1 16 16s-7.1 16-16 16l-81.8 0c-4.1 44.9-41.9 80-87.8 80c-48.7 0-88.2-39.5-88.2-88.2zM21 361.5c0-8.8 7.1-16 16-16l136.5 0c8.8 0 16 7.1 16 16s-7.1 16-16 16L37 377.5c-8.8 0-16-7.1-16-16z'
      
    ]
  };

  

  
  

  var faProgressCheck = {
    prefix: 'fak',
    iconName: 'progress-check',
    icon: [
      512,
      512,
      [],
      'e004',
      
      'M271.8 6.1c27.2 1.9 53.9 8.1 79.1 18.5 30.6 12.6 58.3 31.1 81.7 54.4s41.9 51 54.6 81.4 19.2 63.1 19.2 96.1-6.5 65.6-19.2 96.1-31.2 58.1-54.6 81.4-51.2 41.8-81.7 54.4c-25.2 10.4-52 16.7-79.1 18.5-9.5 .6-17.2-7.1-17.3-16.7s7.7-17.2 17.3-18c13.7-1.1 27.3-3.5 40.5-7.1 24.2-6.8 46.7-17.6 66.8-31.7 .8-.6 1.7-1.1 2.6-1.6 9.4-6.7 18.2-14.2 26.4-22.4 8.4-8.3 16-17.3 22.8-26.9 .4-.7 .7-1.4 1.2-2l-.1 0c13.5-19 24.1-40.3 30.9-63.2 5.8-19.8 8.8-40.3 8.8-61 0-28.4-5.6-56.6-16.5-82.8s-26.9-50.1-47.1-70.3-44.1-36-70.5-46.9c-21-8.7-43.3-14-65.9-15.8-9.5-.8-17.2-8.4-17.3-18s7.7-17.3 17.3-16.7zM105.5 434.9c5.7-5.7 14.8-6 21.3-1.5 25.9 18.3 56 31.1 88.6 36.7 7.9 1.4 14 8.1 14 16.1 0 9.3-7.9 16.5-17.1 15-38.8-6.2-74.6-21.6-105.3-43.5-7.5-5.4-8-16.2-1.5-22.7l0-.1zM21 278.4c8 0 14.8 6 16.1 13.9 5.6 32.5 18.4 62.5 36.7 88.4 4.7 6.5 4.2 15.6-1.5 21.2-6.6 6.5-17.4 6.1-22.8-1.4-22-30.6-37.3-66.3-43.6-105.1-1.6-9.1 5.8-17.1 15.1-17.1zM352 181.2c4.9-4.9 12.9-4.9 17.8 0l.1 0c4.9 4.9 4.9 12.9 0 17.8L231.4 337.9c-4.9 4.9-12.9 4.9-17.8 0l-71.3-71.5c-4.9-4.9-4.9-12.9 0-17.8s12.9-4.9 17.8 0L222.5 311.1 352 181.2zM49.6 109.5c5.4-7.5 16.2-8 22.8-1.5 5.7 5.7 6.1 14.7 1.5 21.3-18.3 25.9-31.1 56-36.7 88.4-1.4 7.9-8.1 13.9-16.1 13.9-9.3 0-16.6-8-15.1-17.2 6.3-38.7 21.6-74.4 43.6-105zM212.4 8.8c9.1-1.6 17.1 5.8 17.1 15 0 8-6.1 14.7-14.1 16-32.6 5.7-62.7 18.4-88.6 36.6-6.6 4.7-15.7 4.2-21.3-1.5-6.5-6.5-6-17.3 1.5-22.7 30.7-21.9 66.5-37.2 105.4-43.5z'
      
    ]
  };

  



export {

  faCheckIn,
  

  faCheckInAlt,
  

  faCheckInDate,
  

  faCheckOut,
  

  faCheckOutAlt,
  

  faCheckOutDate,
  

  faFilter,
  

  faProgressCheck,
  

};
